import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MainService } from '../service/main.service';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  httpUrl;
  constructor(private http: HttpClient, private main: MainService) {
    this.httpUrl = this.main.httpUrl + '/acms/dashboard'
  }



  getFilteredData(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/filteredDashboardData` + obj)
  }

  getTotalCardData(obj: string): Observable<any> {
    return this.http.get(`${this.httpUrl}/getTotalCardData` + obj)
  }

  getPreviewPushData(obj: any): Observable<any> {
    return this.http.post(`${this.main.httpUrl}/acms/darpan/previewPushData`, obj);
  }

  pushDataToDarpan(obj: any): Observable<any> {
    return this.http.post(`${this.main.httpUrl}/acms/integration/pushData`, obj);
  }
  getPushedData(obj: any): Observable<any> {
    return this.http.post(`${this.main.httpUrl}/acms/integration/getPushedData`, obj);
  }

  getPushedDates(obj: any): Observable<any> {
    return this.http.post(`${this.main.httpUrl}/acms/integration/getPushedDates`, obj);
  }

}
